import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { permissions } from "../../store/permissions/actions";
export var usePermissionGetAll = function (trigger, clientId, pageCatalog, limitCatalog, search) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responsePermission: state.Permission.responsePermission,
        errorPermission: state.Permission.errorPermission,
        loadingPermission: state.Permission.loadingPermission,
    }); }), responsePermission = _b.responsePermission, errorPermission = _b.errorPermission, loadingPermission = _b.loadingPermission;
    useEffect(function () {
        if (trigger) {
            dispatch(permissions({
                clientId: clientId,
                search: search,
                enable: enable,
                page: pageCatalog,
                limit: limitCatalog,
            }));
        }
    }, [trigger, clientId]);
    return {
        responsePermission: responsePermission,
        errorPermission: errorPermission,
        loadingPermission: loadingPermission,
        setEnable: setEnable,
    };
};
